"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ethParameterToVarsValue = ethParameterToVarsValue;
exports.ethParametersToVarsValues = ethParametersToVarsValues;
exports.isVarsArray = isVarsArray;
exports.isVarsPrimitive = isVarsPrimitive;
exports.isVarsStruct = isVarsStruct;
exports.isVarsValue = isVarsValue;
var _ethTypes = require("@blockwell/eth-types");
function isVarsValue(it) {
  if (Array.isArray(it)) {
    for (let ele of it) {
      if (!isVarsValue(ele)) {
        return false;
      }
    }
    return true;
  }
  let type = typeof it;
  if (it && type === 'object') {
    for (let val of Object.values(it)) {
      if (!isVarsValue(val)) {
        return false;
      }
    }
    return true;
  }
  return type === "string" || type === "boolean" || type === "number";
}
function isVarsPrimitive(it) {
  let type = typeof it;
  return type === "string" || type === "boolean" || type === "number";
}
function isVarsArray(it) {
  if (Array.isArray(it)) {
    for (let ele of it) {
      if (!isVarsValue(ele)) {
        return false;
      }
    }
    return true;
  }
  return false;
}
function isVarsStruct(it) {
  return typeof it === "object" && !Array.isArray(it);
}
function ethParametersToVarsValues(params) {
  let data = {};
  for (let param of params) {
    if (param.name) {
      data[param.name] = ethParameterToVarsValue(param);
    }
  }
  return data;
}
function ethParameterToVarsValue(param) {
  if ((0, _ethTypes.isTupleParameter)(param)) {
    return ethParametersToVarsValues(param.components);
  }
  if ((0, _ethTypes.isTupleArrayParameter)(param)) {
    return param.values.map(it => ethParametersToVarsValues(it.components));
  }
  if ((0, _ethTypes.isStringArrayParameter)(param) || (0, _ethTypes.isBooleanArrayParameter)(param)) {
    return param.values;
  }
  if ((0, _ethTypes.isIndexedParameter)(param)) {
    return param.hash;
  }
  return param.value;
}
//# sourceMappingURL=VarsValue.js.map